import React from "react";
import { useState } from "react";
import { Link, useNavigate } from "react-router-dom";
import { useLingueStore } from "../../sistema/storeLingua";
// import { useLingueStore } from "../sistema/storeLingua";

export default function AvpSaveFooter({ cancelCallback, saveCallback }) {
  const { selectedLinguaTesto } = useLingueStore((state) => state);

  function handleSave() {
    if (saveCallback != null) {
      saveCallback();
    }
  }
  function handleCancel() {
    if (cancelCallback != null) {
      cancelCallback();
    }
  }

  return (
    <div id="avp-footer-save-container" className="clearfix">
      <div id="avp-footer-save-container-left">
        <div id="avp-footer-save-title">
          {selectedLinguaTesto?.AvpSaveFooterTitle}
        </div>
        <div id="avp-footer-save-subtitle">
          {selectedLinguaTesto?.AvpSaveFooterSubtitle}
        </div>
      </div>

      <div id="avp-footer-save-container-right">
        <div id="avp-footer-save-submit">
          <button onClick={() => handleSave()}>
            {selectedLinguaTesto?.AvpSaveFooterSave}
          </button>
        </div>
        <div id="avp-footer-save-cancel">
          <button onClick={handleCancel}>
            {selectedLinguaTesto?.AvpSaveFooterReset}
          </button>
          {/* <button onClick={()=>handleCancel()} >ANNULLA</button> */}
        </div>
      </div>
    </div>
  );
}
